import app, { u_, vuwer } from "@@assets/scripts/common";

vuwer.add("mainSection", {
	selector: "#main_section",
	onReady($self) {
		if(!$self) {
			return false;
		}
		
		const $content = $self.children(".content");
		const $footer = $content.children(".section-footer");
		this.setProp({ $content, $footer });
		
		const { ym } = app._GET;
		if(ym) {
			$footer.find(".go-list").each((i, elm) => {
				elm.href += u_.createQueryString({ ym });
			});
		}
	}
});
